module.exports = __webpack_public_path__ + "img/index_img3.b1382c8c.png";